function showElement(id, display) {
	document.getElementById(id).style.display = display;
}
